<template>
    <div>
        <sui-message v-if="error" negative>
            <sui-message-header>Select Error</sui-message-header>
            <p>{{ error }}</p>
        </sui-message>
        <sui-dropdown
                v-else
                selection
                :options="currentValue.options"
                :value="currentValue.value" 
                @input="$emit('updateValue', $event); currentValue.value = $event"
                :loading="loading"
            />
    </div>
</template>

<script>
const axios = require('axios');
export default {
    name: 'ModuleSelect',
    methods: {
        fetchOptions()
        {
            this.loading = true;
            let url = this.currentValue.url
            // check #parameters#
            let parameters = url.match(/#([a-zA-Z0-9]+)#/g);
            
            if (parameters && parameters.length>0)
            {
                parameters.forEach(parameter => {
                    let stripped = parameter.replace(/#/g, '');
                    
                    let item = this.$store.getters.findItemByName(stripped);
                    let value = null;
                    if (item && item.value)
                    {
                        value = item.value;
                    }
                    this.watchParameters[stripped] = value;
                    
                    url = url.replace(parameter, value);
                })
            }
            console.log(url);
            axios.get(url)
                .then(response => {
                    this.currentValue.options = response.data;
                    this.loading = false;
                    this.error = false;
                })
                .catch(error => {
                    this.error = error;
                    this.loading = false;
                })   
        }
    },
    data () {
        return {
            currentValue: {},
            loading: false,
            error: null,
            watchParameters: {}
        }
    },
    props: {
        parameters: {
            type: Object,
        },
    },
    watch: {
        currentValue: {
            handler(val) {
                this.$emit('parameters-update', val);
            },
            deep: true
        }
    },
    mounted() {
        this.currentValue = JSON.parse(JSON.stringify(this.parameters));
        if (!this.currentValue.options)
            this.currentValue.options = [];
        if (this.currentValue.optionSource=='remotejson')
        {
            this.fetchOptions();
        }
    },
    created() {
        
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'updateItemValue') {
                
                let name = this.$store.state.app.items[mutation.payload.key].name
                if (typeof this.watchParameters[name] !== 'undefined' && this.watchParameters[name]!=mutation.payload.value)
                {
                    this.fetchOptions();
                }
                
            }
        });
        
        
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
